import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import Applicant from "./Applicant";
import { Header } from './Header';
import { Footer } from './Footer';

export default class Applicants extends Base {
    constructor(props) {
        super(props);
        this.state = {
            caller: props.Caller,
            controllerName: 'applicant',
            data: null,
            loading: true,
            configName: 'applicants_grid',
            moduleName: 'مشتریان'
        };
    }
    componentDidMount() {
        this.refreshData();
    }
    onEdit(id) {
        this.showComponents({ component: <Applicant Caller={this} Id={id} /> });
    }
    onAdd() {
        this.removeKeyDown();
        this.showComponents({ component: <Applicant Caller={this} /> });
    }
    getDefaultConfig() {
        return {
            name: this.state.configName,
            fields: [
                { field: "name", caption: "نام", show: true },
                { field: "nationalId", caption: "کدملی", show: true },
                { field: "phone", caption: "شماره تماس", show: true },
                { field: "dateString", caption: "تاریخ درخواست", show: true },
                { field: "servicePrice", caption: "هزینه خدمات", show: true },
                { field: "labName", caption: "نام آزمایشگاه", show: true },
            ]
        }
    }
    getColumns() {
        var config = this.getGridConfig();
        var t = [];
        config.fields.forEach(f => {
            if (f.field == 'name' && f.show) t.push({ field: f.field, headerName: f.caption, cellRenderer: (props) => { return <a className="text-primary txt-bold hand" onClick={e => this.onEdit(props.data.id)}>{props.data.name}</a> } });
            if (f.field == 'nationalId' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'phone' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'dateString' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'servicePrice' && f.show) t.push({ field: f.field, headerName: f.caption });
            if (f.field == 'labName' && f.show) t.push({ field: f.field, headerName: f.caption });
        });
        return t;
    }
    renderForm() {
        return <div className="nk-content-body">
                <div className="nk-block">
                    <div className="card card-bordered card-stretch">
                        <div className="card-inner-group">
                            <div className="card-inner p-0">
                                {this.getToolBar()}
                                {this.renderAgGrid({
                                    columnDefs: this.getColumns()
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.renderForm()}
                        </div>
                    </div>
                </div>,
                <Footer />,
                this.renderPopupComponent(),
            ];

        return contents;
    }
}